import React, { useRef, useState, useEffect } from 'react';
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  useMapEvents
} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import 'leaflet-geosearch/dist/geosearch.css';

// Marker uchun icon sozlamasi
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const SearchControl = ({ mapRef, setLocation, onReverse }) => {
  const map = useMap();
  const provider = new OpenStreetMapProvider();

  useEffect(() => {
    if (!map) return;

    mapRef.current = map;

    const searchControl = new GeoSearchControl({
      provider,
      style: 'bar',
      showMarker: false,
      retainZoomLevel: false,
      animateZoom: true,
      keepResult: true
    });

    map.addControl(searchControl);

    map.on('geosearch/showlocation', (e) => {
      const { x: lng, y: lat } = e.location;
      const coords = { lat: parseFloat(lat), lng: parseFloat(lng) };

      if (!isNaN(coords.lat) && !isNaN(coords.lng)) {
        setLocation(coords);
        map.flyTo([coords.lat, coords.lng], 14);
        onReverse(coords);
      }
    });

    return () => {
      map.removeControl(searchControl);
    };
  }, [map]);

  return null;
};

const ClickHandler = ({ setLocation, onReverse }) => {
  useMapEvents({
    click(e) {
      const coords = { lat: e.latlng.lat, lng: e.latlng.lng };
      setLocation(coords);
      onReverse(coords);
    }
  });

  return null;
};

export default function MapSelector({ onChange }) {
  const [location, setLocation] = useState(null);
  const mapRef = useRef(null);

  const reverseGeocode = async (coords) => {
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${coords.lat}&lon=${coords.lng}`,
        {
          headers: {
            'User-Agent': 'idokon-map-selector/1.0'
          }
        }
      );
      const data = await res.json();
      const { state: region, county, city, town, village } = data?.address || {};
      const district = county || city || town || village || '';
      onChange({
        lat: coords.lat,
        lng: coords.lng,
        region: region || '',
        district
      });
    } catch (err) {
      console.error("Reverse geocode failed", err);
    }
  };

  const locateMe = (e) => {
    if (!navigator.geolocation) {
      alert("Brauzer joylashuvni qo‘llab-quvvatlamaydi.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const coords = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        };
        setLocation(coords);
        reverseGeocode(coords);
        if (mapRef.current) {
          mapRef.current.flyTo([coords.lat, coords.lng], 14);
        }
      },
      (err) => {
        alert("Joylashuvni olishda xatolik: " + err.message);
      }
    );
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <label className="mb-0">📍 Manzilni tanlang yoki xaritada belgilang:</label>
        <button
          type="button"
          onClick={locateMe}
          className="btn btn-outline-primary btn-sm"
        >
          Mening joylashuvim
        </button>

      </div>

      <MapContainer
        center={[41.3111, 69.2797]} // Tashkent markazi
        zoom={7}
        style={{ height: '300px', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <SearchControl
          mapRef={mapRef}
          setLocation={setLocation}
          onReverse={reverseGeocode}
        />
        <ClickHandler
          setLocation={setLocation}
          onReverse={reverseGeocode}
        />
        {location && <Marker position={[location.lat, location.lng]} />}
      </MapContainer>
    </div>
  );
}
